type AgendaTimeSlotProps = {
    startDate: Date;
    endDate: Date;
};

export default class AgendaTimeSlot {
    startDate: Date;

    endDate: Date;

    constructor(props: AgendaTimeSlotProps) {
        this.startDate = props.startDate;
        this.endDate = props.endDate;
    }
}
